"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormFacadeSummary", {
    enumerable: true,
    get: function() {
        return FormFacadeSummary;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Option = require("./model/Option");
const _contexts = require("../../../contexts");
const _FormSelectFacade = require("../FormSelect/FormSelectFacade");
const _localisationeq1 = require("@equiem/localisation-eq1");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const MAX_ICON_DISPLAY = 5;
const FormFacadeSummary = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { localValue, options, disabled = false, emptyLabel, showChrome, className = "" } = param;
    const theme = (0, _contexts.useTheme)();
    const { t } = (0, _localisationeq1.useTranslation)();
    const icons = localValue.length > 0 ? localValue.slice(0, MAX_ICON_DISPLAY) : [];
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_FormSelectFacade.FormSelectFacade, {
        disabled: disabled,
        className: className,
        ref: ref,
        showChrome: showChrome
    }, /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, icons.length > 0 ? /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "33ae7d71ac7742bd",
                [
                    theme.spacers.s3,
                    theme.spacers.s3,
                    theme.spacers.s3
                ]
            ]
        ]) + " " + "multi"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "33ae7d71ac7742bd",
                [
                    theme.spacers.s3,
                    theme.spacers.s3,
                    theme.spacers.s3
                ]
            ]
        ]) + " " + "group"
    }, icons.map((value)=>{
        const option = options.find((o)=>o.value === value);
        return option == null ? null : /*#__PURE__*/ _react.default.createElement("div", {
            key: option.value,
            className: _style.default.dynamic([
                [
                    "33ae7d71ac7742bd",
                    [
                        theme.spacers.s3,
                        theme.spacers.s3,
                        theme.spacers.s3
                    ]
                ]
            ]) + " " + "individual"
        }, (0, _Option.optionLabel)(option, true));
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "33ae7d71ac7742bd",
                [
                    theme.spacers.s3,
                    theme.spacers.s3,
                    theme.spacers.s3
                ]
            ]
        ])
    }, t("requests.details.watcher", {
        count: localValue.length
    }))) : /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, emptyLabel))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "33ae7d71ac7742bd",
        dynamic: [
            theme.spacers.s3,
            theme.spacers.s3,
            theme.spacers.s3
        ]
    }, ".multi.__jsx-style-dynamic-selector{gap:".concat(theme.spacers.s3, ";padding:0 ").concat(theme.spacers.s3, "}.group.__jsx-style-dynamic-selector,.multi.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.individual.__jsx-style-dynamic-selector{margin-left:-").concat(theme.spacers.s3, "}")));
});
FormFacadeSummary.displayName = "FormFacadeSummary";

//# sourceMappingURL=FormFacadeSummary.js.map